import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import {
  FButton,
  FCard,
  FContainer,
  FGrid,
  FGridItem,
  FItem,
  FTypo,
} from "ferrum-design-system";
import IconNetworkCFrmStr from "../../../../../assets/img/icon-network-cfrm.svg";
import IconNetworkCFrmxStr from "../../../../../assets/img/icon-network-cfrmx.svg";
import IconNetworkBNB from "../../../../../assets/img/icon-network-bnb.svg";
import { ReactComponent as IconNetworkLeaderboard } from "../../../../../assets/img/icon-network-leaderboard.svg";
import { ReactComponent as IconCongrats } from "../../../../../assets/img/icon-check-congrats.svg";

import { CrucibleMyBalance } from "../../../common/CardMyBalance";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/rootReducer";
import * as CrucibleActions from "../../../redux/CrucibleActions";
import * as SFSH_API from "../../../../../_apis/StepFlowStepHistory";
import toast from "react-hot-toast";
import {
  getLatestStepToRender,
  getObjectReadableFarmName,
} from "../../../common/Helper";
import {
  Crucible_Farm_Address_Details,
  STEP_FLOW_IDS,
} from "../../../common/utils";
import { ClipLoader } from "react-spinners";
import { PATH_DASHBOARD } from "../../../../../routes/paths";
import { getErrorMessage } from "../../../../../utils/global.utils";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { tokenSymbols } from "../../../../../utils/constants";
export const Success = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const location: any = useLocation();
  const crucible = useSelector(
    (state: RootState) => state.crucible.selectedCrucible
  );
  let { farm } = useParams<{ farm?: string }>();
  farm = farm === "cFRM-ARBITRUM" ? "cTestFrm" : farm;
  const history = useHistory();
  const { stepFlowStepHistory, currentStep, currentStepIndex } = useSelector(
    (state: RootState) => state.crucible
  );
  const { tokenV2, currentNetworkInformation } = useSelector(
    (state: RootState) => state.walletAuthenticator
  );
  const { activeTranslation } = useSelector((state: RootState) => state.phrase);
  const { theme, content } = useSelector((state: RootState) => state.config);

  console.log({ location });
  useEffect(() => {
    if (location.state === undefined) {
      history.push({ pathname: PATH_DASHBOARD.crucible.index });
    }
  }, [location]);

  useEffect(() => {
    if (
      currentStep &&
      currentStep._id &&
      currentStep.status === "pending" &&
      currentStep.step.name === "Success"
    ) {
      getStepCompleted(false);
    }
  }, [currentStep]);

  const getStepCompleted = async (renderNeeded: any) => {
    setIsLoading(true);
    try {
      let updatedCurrentStep = { ...currentStep, status: "completed" };
      let updHistory = stepFlowStepHistory.map((obj, index) =>
        index === currentStepIndex ? { ...obj, status: "completed" } : obj
      );
      let data = { status: "completed" };

      dispatch(
        CrucibleActions.updateCurrentStep({
          currentStep: updatedCurrentStep,
          currentStepIndex: currentStepIndex,
        })
      );
      dispatch(
        CrucibleActions.updateStepFlowStepHistory({
          stepFlowStepHistory: updHistory,
        })
      );

      // let updateResponse: any =
      await SFSH_API.updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId(
        currentStep._id,
        data,
        tokenV2
      );
      // console.log('updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId', 'staking mint success 65')
      // updateResponse = updateResponse?.data?.body?.stepsFlowStepHistory;
      getLatestStepToRender(
        location.state,
        tokenV2,
        currentStep,
        currentStepIndex,
        stepFlowStepHistory,
        dispatch,
        history,
        farm,
        setIsLoading,
        renderNeeded
      );
    } catch (e: any) {
      getErrorMessage(e, activeTranslation);
    }
  };

  const crucibleWlConfig = theme.crucibleConfig;
  const customClaimLink = crucibleWlConfig?.customClaimLink.match(/^https?:/)
    ? crucibleWlConfig?.customClaimLink
    : "//" + crucibleWlConfig?.customClaimLink;

  const onMintClick = () => {
    setIsLoading(true);
    let nextStepInfo: any;
    let newFarm: any;
    if (farm?.includes("BNB")) {
      if (farm?.includes("cFRMx")) {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName("cFRM-BNB")}`].dashboard;
        newFarm = "cFRM-BNB";
      } else {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName("cFRMx-BNB")}`].dashboard;
        newFarm = "cFRMx-BNB";
      }
    } else {
      if (farm === "cFRMx") {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName("cFRMx")}`].mint;
        newFarm = "cFRMx";
      } else if (farm === "cFRM") {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName("cFRM")}`].mint;
        newFarm = "cFRM";
      } else if (farm === "cTestFrm") {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName("cTestFrm")}`].mint;
        newFarm = "cTestFrm";
      } else if (farm === "cLEO") {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName("cLEO")}`].mint;
        newFarm = "cLEO";
      }
    }

    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    location.state = {
      ...location.state,
      ...Crucible_Farm_Address_Details[newFarm],
    };
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      newFarm,
      setIsLoading
    );
  };
  const onStakeClick = () => {
    if (farm?.includes("cLEO")) {
      window.open(theme?.crucibleConfig?.customClaimLink, "_blank");
      return;
    } else {
      setIsLoading(true);
      let nextStepInfo: any =
        STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].stake;
      location.state.id = nextStepInfo.id;
      location.state.stepFlowName = nextStepInfo.name;
      location.state = {
        ...location.state,
        ...Crucible_Farm_Address_Details[farm!],
      };
      getLatestStepToRender(
        location.state,
        tokenV2,
        currentStep,
        currentStepIndex,
        stepFlowStepHistory,
        dispatch,
        history,
        farm,
        setIsLoading
      );
    }
  };

  const onAddLiquidityClick = () => {
    setIsLoading(true);
    // let nextStepInfo: any = STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].generalAddLiquidity;
    let nextStepInfo: any;
    let newFarm: any;
    if (farm?.includes("cFRM")) {
      nextStepInfo = STEP_FLOW_IDS[`${getObjectReadableFarmName("cFRM")}`].mint;
      newFarm = "cFRM";
    } else if (farm === "cTestFrm") {
      nextStepInfo =
        STEP_FLOW_IDS[`${getObjectReadableFarmName("cTestFrm")}`].mint;
      newFarm = "cTestFrm";
    } else if (farm?.includes("cLEO")) {
      nextStepInfo =
        STEP_FLOW_IDS[`${getObjectReadableFarmName("cLEO")}`].mintAndStake;
      newFarm = "cLEO";
    } else {
      nextStepInfo =
        STEP_FLOW_IDS[`${getObjectReadableFarmName("cFRMx")}`].mint;
      newFarm = "cFRMx";
    }
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    location.state = {
      ...location.state,
      ...Crucible_Farm_Address_Details[newFarm],
    };
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      newFarm,
      setIsLoading
    );
  };

  const onTradeClick = () => {
    let dexUrl =
      theme?.crucibleConfig?.baseCurrency?.dexLink ||
      currentNetworkInformation?.networkCurrencyAddressByNetwork?.networkDex
        ?.dex?.url;
    let tradeURL;
    if (farm?.includes("cTestFrm")) {
      tradeURL =
        "https://app.sushi.com/swap?inputCurrency=0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA&outputCurrency=0xe685d3CC0be48BD59082eDe30C3b64CbFc0326e2&chainId=42161";
    } else if (
      farm?.includes("cLEO") &&
      theme?.crucibleConfig?.baseCurrency?.dexLink
    ) {
      tradeURL = `${
        dexUrl.split("swap?")[0]
      }swap?inputCurrency=BNB&outputCurrency=${
        crucible[farm!].contractAddress
      }&exactField=output&exactAmount=`;
    } else {
      tradeURL = "https://app.sushi.com/swap?inputCurrency=0xe685d3CC0be48BD59082eDe30C3b64CbFc0326e2&outputCurrency=0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA&chainId=42161";
    }
    window.open(tradeURL, "_blank");
  };

  const onClaimRewardsClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].withdraw;
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
    setIsLoading(false);
  };

  const onLeaderboardClick = () => {
    let leaderboardUrl;
    if (farm?.includes("cTestFrm")) {
      leaderboardUrl = `${window.location.origin}/dashboard/crucible`;
      window.open(leaderboardUrl, "_self");
      return;
    } else if (farm?.includes("cLEO")) {
      const nextStepInfo =
        STEP_FLOW_IDS[`${getObjectReadableFarmName("cLEO")}`].unwrap;
      const newFarm = "cLEO";
      location.state.id = nextStepInfo.id;
      location.state.stepFlowName = nextStepInfo.name;
      location.state = {
        ...location.state,
        ...Crucible_Farm_Address_Details[newFarm],
      };
      getLatestStepToRender(
        location.state,
        tokenV2,
        currentStep,
        currentStepIndex,
        stepFlowStepHistory,
        dispatch,
        history,
        newFarm,
        setIsLoading
      );
      return;
    } else {
      leaderboardUrl = `${window.location.origin}/pub/multi/leaderboard/61b6d48337f5125acbbfddeb`;
      window.open(leaderboardUrl, "_self");
      return;
    }
  };
  const GlobalStyles = createGlobalStyle`
  .card-congrats{
   .crucible-congrats-card{
     background-image: url(${theme?.cards?.crucibleCongratsCard}) !important;
   }
   .crucible-info-card{
     background-image: url(${theme?.cards?.crucibleCongratsInfoCard}) !important;
   }
  }
  
 `;

  const farmLabel = farm?.includes("cFRMx")
    ? "cFRMx"
    : farm?.includes("cLEO")
    ? "cLEO"
    : "cFRM";

  return (
    <>
      <ThemeProvider theme={theme}>
        {isLoading ? (
          // <FCard>
          <FItem align={"center"}>
            <ClipLoader
              color={theme?.colors?.primary}
              loading={true}
              size={150}
            />
          </FItem>
        ) : (
          <FContainer width={1100}>
            <div className="d-flex">
              <div className="card-congrats">
                <FItem bgColor={theme?.cards?.crucibleCongratsCard}>
                  <div className="crucible-congrats-card">
                    <FTypo
                      color={theme?.colors?.primary}
                      size={40}
                      weight={600}
                    >
                      Congratulations!
                    </FTypo>
                    <FTypo
                      color={theme?.colors?.primaryLight}
                      size={32}
                      weight={500}
                      className="f-mt-1"
                    >
                      {location?.state?.json[0]?.success?.header ||
                        content?.success?.header}
                    </FTypo>
                    <FTypo
                      color={theme?.colors?.primaryLight}
                      size={16}
                      className="f-mt-1 f-mb-1"
                    >
                      {location?.state?.json[0]?.success?.description ||
                        content?.success?.description}
                    </FTypo>
                  </div>
                </FItem>
                <FGrid className={"f-mt-3"}>
                  <FGridItem size={[6, 6, 6]} className="f-mb-2">
                    <FItem
                      bgColor={theme?.cards?.crucibleCongratsInfoCard}
                      className={"crucible-info-card"}
                    >
                      <div className="" onClick={() => onMintClick()}>
                        <div className="f-mb-1">
                          <span className="icon-wrap d-flex">
                            <img
                              src={IconNetworkBNB}
                              height="40px"
                              width="40px"
                              alt=""
                            />
                            {farm?.includes("cLEO") ? (
                              <img
                                src={(tokenSymbols as any)[farmLabel]}
                                height="40px"
                                width="40px"
                                alt=""
                              />
                            ) : farm?.includes("cFRMx") ? (
                              <img
                                src={IconNetworkCFrmxStr}
                                height="40px"
                                width="40px"
                                alt=""
                              />
                            ) : (
                              <img
                                src={IconNetworkCFrmStr}
                                height="40px"
                                width="40px"
                                alt=""
                              />
                            )}
                            <FTypo
                              color={theme?.colors?.primaryLight}
                              size={20}
                              className="f-mt--5 f-ml-1"
                              weight={400}
                              align={"start"}
                            >
                              {/* Add Liquidity & Compound Rewards */}
                              {location?.state?.json[0]?.success?.cards[0]
                                ?.header ||
                                content?.success?.cards[0]?.header}{" "}
                            </FTypo>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex">
                        <FTypo color={theme?.colors?.primaryLight} size={12}>
                          {location?.state?.json[0]?.success?.cards[0]
                            ?.description ||
                            content?.success?.cards[0]?.description}
                        </FTypo>
                      </div>
                    </FItem>
                  </FGridItem>
                  <FGridItem size={[6, 6, 6]}>
                    <FItem
                      bgColor={theme?.cards?.crucibleCongratsInfoCard}
                      className={"crucible-info-card"}
                    >
                      <div
                        className="card-whats-next-inner"
                        onClick={() => onStakeClick()}
                      >
                        <div className="card-whats-next-front">
                          <div className="network-icon-wrapper text-center f-mb-1">
                            <span className="icon-wrap d-flex">
                              {farm?.includes("cLEO") ? (
                                <img
                                  src={(tokenSymbols as any)[farmLabel]}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : farm?.includes("cFRMx") ? (
                                <img
                                  src={IconNetworkCFrmxStr}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : farm?.includes("cFRM") ? (
                                <img
                                  src={IconNetworkCFrmStr}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : (
                                <img
                                  src={IconNetworkCFrmStr}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              )}
                              <FTypo
                                color={theme?.colors?.primaryLight}
                                size={20}
                                weight={400}
                                align={"left"}
                                className="f-mt--5 f-ml-1"
                              >
                                {location?.state?.json[0]?.success?.cards[1]
                                  ?.header ||
                                  content?.success?.cards[1]?.header}
                              </FTypo>
                            </span>
                          </div>
                        </div>
                        <div className="card-whats-next-back">
                          <FTypo color={theme?.colors?.primaryLight} size={12}>
                            {location?.state?.json[0]?.success?.cards[1]
                              ?.description ||
                              content?.success?.cards[1]?.description}
                          </FTypo>
                        </div>
                      </div>
                    </FItem>
                  </FGridItem>
                  <FGridItem size={[6, 6, 6]}>
                    <FItem
                      bgColor={theme?.cards?.crucibleCongratsInfoCard}
                      className={"crucible-info-card"}
                    >
                      <div onClick={() => onClaimRewardsClick()}>
                        <div className="card-whats-next-front">
                          <div className="network-icon-wrapper f-mb-1">
                            <span className="icon-wrap d-flex">
                              {farm?.includes("cLEO") ? (
                                <img
                                  src={(tokenSymbols as any)[farmLabel]}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : farm?.includes("cFRMx") ? (
                                <img
                                  src={IconNetworkCFrmxStr}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : (
                                <img
                                  src={IconNetworkCFrmStr}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              )}
                              <FTypo
                                color={theme?.colors?.primaryLight}
                                size={20}
                                weight={400}
                                className="f-mt--5 f-ml-1"
                                align={"start"}
                              >
                                {location?.state?.json[0]?.success?.cards[2]
                                  ?.header ||
                                  content?.success?.cards[2]?.header}
                              </FTypo>
                            </span>
                          </div>
                        </div>
                        <div className="card-whats-next-back">
                          <FTypo color={theme?.colors?.primaryLight} size={12}>
                            {location?.state?.json[0]?.success?.cards[2]
                              ?.description ||
                              content?.success?.cards[2]?.description}
                          </FTypo>
                        </div>
                      </div>
                    </FItem>
                  </FGridItem>
                  <FGridItem size={[6, 6, 6]}>
                    <FItem
                      // bgColor={theme?.cards?.crucibleCongratsInfoCard}
                      className={"crucible-info-card"}
                    >
                      <div onClick={() => onTradeClick()}>
                        <div className="card-whats-next-front">
                          <div className="network-icon-wrapper f-mb-1">
                            <span className="icon-wrap d-flex">
                              {!theme?.crucibleConfig?.isDashboardEnabled ? (
                                <img
                                  src={
                                    theme?.crucibleConfig?.baseCurrency?.cabn
                                      ?.currency?.logo
                                  }
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : farm?.includes("cLEO") ? (
                                <img
                                  src={(tokenSymbols as any)[farmLabel]}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : farm?.includes("cFRMx") ? (
                                <img
                                  src={IconNetworkCFrmStr}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              ) : (
                                <img
                                  src={IconNetworkCFrmStr}
                                  height="40px"
                                  width="40px"
                                  alt=""
                                />
                              )}
                              <FTypo
                                color={theme?.colors?.primaryLight}
                                size={20}
                                weight={400}
                                className="f-mt--5"
                                align={"start"}
                              >
                                {location?.state?.json[0]?.success?.cards[3]
                                  ?.header ||
                                  content?.success?.cards[3]?.header}
                              </FTypo>
                            </span>
                          </div>
                          <FTypo color={theme?.colors?.primaryLight} size={12}>
                            {location?.state?.json[0]?.success?.cards[3]
                              ?.description ||
                              content?.success?.cards[3]?.description}
                          </FTypo>
                        </div>
                      </div>
                    </FItem>
                  </FGridItem>
                  <FGridItem className="d-flex jc-end">
                    <FButton
                      title={
                        <Link
                          to="/dashboard/crucible"
                          className="go-back w-100 align-right"
                          style={{ fontSize: "15px" }}
                        >
                          <FTypo color={theme?.colors?.neutral}>
                            Go To Crucible Dashboard
                          </FTypo>
                        </Link>
                      }
                      variant="primary"
                      className="w-100 f-mr-10"
                      style={{ width: "500px" }}
                    />
                  </FGridItem>
                </FGrid>
              </div>
            </div>
          </FContainer>
        )}
        <GlobalStyles />
      </ThemeProvider>
    </>
  );
};
